import { createContext } from "react";

type BadgeSize = "default" | "small";

export const BadgeSizeContext = createContext<BadgeSize | undefined>(undefined);
